import sdk from '@/src/service/auth-sdk'

export const API_MAP_SEARCH = {
  advancedSearch(data) {
    return sdk
      .request({ url: 'map/advanced-search', method: 'post', data })
      .then((res) => res.data)
  },
  exportSearch(data) {
    return sdk.request({
      url: 'map/export-search',
      method: 'post',
      data,
      responseType: 'blob',
    })
  },
  getProvinces() {
    return sdk
      .request({ url: 'provinces', method: 'get' })
      .then((res) => res.data)
  },
}
